import { useRef } from 'react';
import './Footer.css';

export default function Footer() {
    function moveToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    return (
        <div className="footer">
            <div className="top" onClick={moveToTop}>
                TOP
            </div>
            <div className="footer__container">
                <div className="footer__links">
                    <div className="footer__link">關於 Stylish</div>
                    <div className="footer__link">服務條款</div>
                    <div className="footer__link">隱私政策</div>
                    <div className="footer__link">聯絡我們</div>
                    <div className="footer__link">FAQ</div>
                </div>
                <div className="footer__social-media">
                    <div className="footer__social-media-line" />
                    <div className="footer__social-media-twitter" />
                    <div className="footer__social-media-facebook" />
                </div>
                <div className="footer__copyright">© 2022. All rights reserved.</div>
            </div>
        </div>
    );
}
